
import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapState } from 'vuex';

@Component({
  computed: {
    ...mapState('moduleUser', { user: 'user' }),
  },
})
export default class SchedulerCard extends Vue {
  @Prop({ type: Object || Boolean, required: true }) public readonly board: { ['string']: string };
}
